export default __webpack_public_path__ + "static/media/keto_drinks@3x.cc0e18db.jpg";